export enum ApplicationDetailsSubmissionSteps {
  IncomeSourcesStep = 'IncomeSourcesStep',
  AcceptLegalDocumentsStep = 'AcceptLegalDocumentsStep',
  CreditAndAutoOriginationCheckStep = 'CreditAndAutoOriginationCheckStep',
}
